// extracted by mini-css-extract-plugin
module.exports = {"AnswerItem":"AnswerItem_AnswerItem__3hD4y","success":"AnswerItem_success__B12bY","error":"AnswerItem_error__3DQav"};